import initialState from "core/reducers/initialState";
import DictionaryUtil from "core/util/dictionary/DictionaryUtil";
import TokenSession from "core/util/session/TokenSession";
import React from "react";
import { connect } from "react-redux";
import Label from "./Label";

/**
 * render the title of a panel (with language support)
 *
 * @author chills
 */

interface IOwnProps {
	instance: string;
}

interface IStateProps {
	value: string;
}

function mapStateToProps(state: typeof initialState = initialState, ownProps: IOwnProps): IStateProps {

	const sPanel = state.config.panels[ownProps.instance];

	return {
		value: sPanel.title
	};
}

type ResultProps = IStateProps & IOwnProps;

export default connect(mapStateToProps)((props: ResultProps) => <Label k={`panel.${props.instance}.title`} v={props.value || null} />);



// WEBPACK FOOTER //
// ./src/core/components/label/PanelTitle.tsx